import { createContext } from 'react';
import { decorate, observable, action, toJS } from 'mobx';

export class ExamElementMultipleUpdate {
    type = null;
    existingElements = null;
    hasUnsavedChanges = false;

    load = (existingElements, saveToServer) => {
        this.clear();

        const distinctInputTypes = existingElements.reduce((array, element) => {
            if (!array.some(a => a === element.type)) {
                array.push(element.type);
            }
            return array;
        }, []);

        if (!distinctInputTypes || distinctInputTypes.length !== 1) {
            throw new Error('Cannot update multiple element types at the same time.');
        }
        else {
            this.type = distinctInputTypes[0];
            this.saveToServer = saveToServer;
            this.existingElements = existingElements && existingElements.length > 0 ? existingElements : [];
        }

        return Promise.resolve();
    }

    setMetadata = (key, value) => {
        if (this.existingElements && this.existingElements.length > 0) {
            for (let ei = 0; ei < this.existingElements.length; ei++) {
                let metadata = this.existingElements[ei].metadata;

                if (!metadata) {
                    metadata = {};
                }

                if (!metadata.hasOwnProperty(key)) {
                    metadata = { ...metadata, ...{ [key]: value } };
                } else {
                    metadata[key] = value;
                }

                this.existingElements[ei].metadata = metadata;
            }
        }
    }

    removeMetadata = (key) => {
        if (this.existingElements && this.existingElements.length > 0) {
            for (let ei = 0; ei < this.existingElements.length; ei++) {
                let metadata = this.existingElements[ei].metadata;

                if (metadata && metadata.hasOwnProperty(key)) {
                    delete metadata[key];
                }
            }
        }
    }

    getMetadata = (key) => {
        let values;

        if (this.existingElements && this.existingElements.length > 0) {
            values = this.existingElements.reduce((array, input) => {
                const value = !input.metadata ? undefined : input.metadata[key];
                if (!array.some(a => a === value)) {
                    array.push(value);
                }
                return array;
            }, []);
        }

        return values && values.length === 1 ? values[0] : null;
    }

    setPosition = (key, value) => {
        let position = this.data.position;

        if (!position.hasOwnProperty(key)) {
            position = { ...position, ...{ [key]: value } };
        } else {
            position[key] = value;
        }

        this.data.position = position;
    }

    save = () => {
        const that = this;

        return new Promise((resolve) => {
            const option = toJS(that.data);
            that.hasUnsavedChanges = false;
            resolve(option);
        })
    }

    clear = () => {
        this.type = null;
        this.existingElements = null;
        this.hasUnsavedChanges = false;
    }
}

decorate(ExamElementMultipleUpdate, {
    type: observable,
    existingElements: observable,
    hasUnsavedChanges: observable,
    load: action,
    save: action,
    setMetadata: action,
    removeMetadata: action,
    getMetadata: action,
    setPosition: action,
    clear: action,
})

export default createContext(new ExamElementMultipleUpdate());